module.exports = __webpack_public_path__ + "static/media/gi_wire_8swg.b7c6cbcc.webp";